import React from "react";
import Navbar from '../Auth/Navbar'
import '../Styles/Careers.css';

function CareersNew() {
    return (
        <React.Fragment>
            <Navbar />
            <div className="careers-container">
                <h1 className="careers-title">Careers</h1>
                <p className="careers-description">
                    We're hiring a visionary Chief Technology Officer (CTO) to lead the tech at GetQuickCare. If you're interested, please fill out the application form below.
                </p>
                <a
                    href="https://forms.gle/kcLSCkmYvQu4CUzx6" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="careers-button"
                >
                    Apply Now
                </a>
            </div>
        </React.Fragment>
    );
}

export default CareersNew;